import React, { useState, useEffect, useRef } from "react";

import { Branding } from "../Header/Header";
import Footer from "../Footer/Footer";
import "./Settings.scss";
import ToastNotification from "../Utilities/ToastNotification";
import AddStopDetails from "./AddStopDetails";
import SettingsAction from "./SettingsAction";
import $ from "jquery";

import { getStopInfo, getStopRoutes, getRouteColours } from "./../API/API";

function Settings(props) {
  const [settingStops, setSettingStops] = useState([]);
  const [routeColours, setRouteColours] = useState({});
  const [toastShow, setToastShow] = useState(false);
  const [toastAutoHide, setToastAutoHide] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [disableSave, setDisableSave] = useState(true);
  const [newURL, setNewURL] = useState("");
  const [pageLoad, setPageLoad] = useState(false);

  const isFirstRun = useRef(true);

  // set 6 empty Stops on page load
  useEffect(() => {
    // fetch 'stop' parameter from URL on page load
    let url = new URL(window.location.href);
    let search_params = url.searchParams;
    let stopIDs = search_params.getAll("stop");

    // start with empty stop array when page loads/history URL changes
    let stops = [];
    setDisableSave(true);

    for (let i = 0; i < 6; i++) {
      stops[i] = {
        trackerID: stopIDs[i] ? stopIDs[i] : "",

        disableButton: true,
      };
    }
    setSettingStops(stops);

    // trigger page load/history URL change to reload data
    setPageLoad(true);
  }, [props.location.search]);

  // reload tracker ID stop information on page load/history URL change
  useEffect(() => {
    if (pageLoad && settingStops.length > 0) {
      for (let i = 0; i < settingStops.length; i++) {
        if (settingStops[i].trackerID) {
          getStopRouteInformation(settingStops[i].trackerID, i);
        }
      }
      setPageLoad(false);
      cleanNewURL();
    }
    // eslint-disable-next-line
  }, [pageLoad]);

  // Delay on input focus so that element can load
  setTimeout(() => {
    if (
      isFirstRun.current &&
      settingStops.length > 0 &&
      settingStops[0].trackerID === ""
    ) {
      document.getElementById("input-id-0").focus();
      isFirstRun.current = false;
    }
  }, 1500);

  function inputChange(event, index) {
    let stops = [...settingStops];

    // Invalid tracker ID check
    if (event.target.value && /^\d+$/.test(event.target.value) === false) {
      stops[index].error = "That's not a valid ID";
    } else {
      // Remove error
      stops[index].error = "";
      stops[index].trackerID = event.target.value;

      stops[index].disableButton = event.target.value.length === 4 ? false : true;
    }

    // Remove error message when field is blank
    if (!event.target.value) {
      stops[index].error = "";
    }

    setSettingStops(stops);
  }

  // check for input 4 character validation when focus out
  function inputBlur(event, index) {
    let stops = [...settingStops];

    if (event.target.value && event.target.value.length < 4) {
      stops[index].error = "That's not a valid ID";
    } else {
      stops[index].error = "";
    }

    setSettingStops(stops);
  }

  // remove error once user click on the input field
  function inputClick(index) {
    fieldRemoveError(index);
  }

  function fieldRemoveError(index) {
    if (settingStops[index].error) {
      let stops = [...settingStops];
      stops[index].error = "";
      setSettingStops(stops);
      setToastShow(false);
    }
  }

  function addStop(index) {
    let url = new URL(window.location.href);
    let search_params = url.searchParams;

    let stopIDs = search_params.getAll("stop");

    let newStopID = settingStops[index].trackerID;
    let appendStop = true;

    // check if stop tracker ID already exists in the URL
    if (stopIDs.length > 0) {
      for (let i = 0; i < stopIDs.length; i++) {
        if (stopIDs[i] === newStopID) {
          showToastNotification(i, "Stop Tracker ID is already on the list.");
          appendStop = false;
          break;
        }
      }
    }

    if (!appendStop) {
      return;
    }

    getStopRouteInformation(newStopID, index);
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  function getStopRouteInformation(stopID, index) {
    let stops = [...settingStops];
    // Display loading spinner icon
    stops[index].addButtonSpinner = true;
    setSettingStops(stops);

    // Get new Stop Tracker ID Information details from APIs
    Promise.all([getStopInfo(stopID), getStopRoutes(stopID), getRouteColours()])
      .then(([newStopResponse, routesResponse, routeColours]) => {
        if (newStopResponse.hasError) {
          stops[index].error = "That's not a valid ID";
          setSettingStops(stops);
          showToastNotification(index, newStopResponse.errorMessage);
        } else {
          //Put returned values where they need to be, and they will get filled as the Promises resolve
          newStopResponse.routes =
            routesResponse.length > 0 ? routesResponse.map((a) => a.RouteNo) : [];
          newStopResponse.trackerId = stopID;
          setRouteColours(routeColours);

          // re-fetch state values
          stops = [...settingStops];
          stops[index].stopInformation = newStopResponse;
          stops[index].addButtonSpinner = false;

          // generate url only when triggered from button click, so checking if button is disabled i.e. triggered from page load
          if (!stops[index].disableButton) {
            let url = new URL(window.location.href);
            let search_params = url.searchParams;
            // append URL params with new Stop ID
            search_params.append("stop", stopID);
            url.search = search_params.toString();
            let new_url = url.toString();
            window.history.pushState({ path: new_url }, "", new_url);

            cleanNewURL();
          }

          sortSetStops(stops);
        }
      })
      .catch((error) => {
        showToastNotification(index, "tramTracker service is not responding.");
        console.log("Loading failed: " + error);
      });
  }

  function deleteStop(index) {
    let stops = [...settingStops];

    if (stops[index].deleteSelected) {
      stops[index] = {
        trackerID: "",
        disableButton: true,
      };

      let url = new URL(window.location.href);
      let search_params = url.searchParams;

      search_params.delete("stop");
      for (let i = 0; i < stops.length; i++) {
        if (stops[i].trackerID) {
          search_params.append("stop", stops[i].trackerID);
        }
      }
      url.search = search_params.toString();
      let new_url = url.toString();

      window.history.pushState({ path: new_url }, "", new_url);

      sortSetStops(stops);

      cleanNewURL();
    } else {
      buttonBlur();
      stops = [...settingStops];
      stops[index].deleteSelected = true;
      setSettingStops(stops);
      setDisableSave(true); // Disable save button on first delete click select
    }
  }

  function cleanNewURL() {
    // remove settings route from the URL
    let currentURL = window.location.href;
    setNewURL(currentURL.replace("settings", ""));
  }

  function buttonBlur() {
    let stops = [...settingStops];

    if (stops.length > 0) {
      for (let i = 0; i < 6; i++) {
        if (stops[i].deleteSelected) {
          stops[i].deleteSelected = false;
          setSettingStops(stops);
          setDisableSave(false); // enable save button on delete button focus out
        }
      }
    }
  }

  // implemented delete focus/blur/select actions with on container click since all browsers don't support focus() and blur()
  $(".grid-container.settings")
    .unbind()
    .click((event) => {
      event.preventDefault();

      if (settingStops.length > 0) {
        // check if click is on Button element including the svg icon inside it
        if (
          event.target.hasAttribute("data-index") ||
          event.target.tagName === "path" ||
          event.target.tagName === "svg"
        ) {
          let index = -1;

          if (event.target.tagName === "path" || event.target.tagName === "svg") {
            // if clicked element is svg, find the parent to get the clicked button array index
            index = $(event.target).closest(".btn-delete").attr("data-index");
          } else {
            // get clicked button array index
            index = event.target.getAttribute("data-index");
          }

          if (index >= 0) {
            deleteStop(index);
          }
        } else {
          // deselect/blur delete button when clicked elsewhere on screen
          buttonBlur();
        }
      }
    });

  function showToastNotification(index, message) {
    let stops = [...settingStops];
    stops[index].addButtonSpinner = false;
    setSettingStops(stops);

    setToastMessage(message);
    setToastAutoHide(false);
    setToastShow(true);
  }

  function sortSetStops(stops) {
    // sort empty trackerID to last in array of objects
    stops.sort((a, b) => {
      return (a.trackerID === "") - (b.trackerID === "");
    });

    // disable save button if all stop IDs are deleted
    if (stops.length > 0 && stops[0].trackerID !== "") {
      setDisableSave(false);
    } else {
      setDisableSave(true);
    }
    setSettingStops(stops);
  }

  function showCopiedNotification() {
    setToastMessage("URL Copied.");
    setToastAutoHide(true);
    setToastShow(true);
  }

  return (
    <div className="grid-container settings">
      <header className="header">
        <Branding />
      </header>

      <main className="tracker">
        <div className="main-content">
          <div className="heading-title border-bottom">
            <h2 className="no-margin">PID set up; enter TTID</h2>
          </div>

          <div className="stops-container">
            {settingStops.map((stop, index) => (
              <AddStopDetails
                key={index}
                stop={stop}
                index={index}
                addStop={addStop}
                routeColours={routeColours}
                inputChange={inputChange}
                inputBlur={inputBlur}
                inputClick={inputClick}
              />
            ))}
          </div>

          <SettingsAction
            disableSave={disableSave}
            newURL={newURL}
            showCopiedNotification={showCopiedNotification}
          />
        </div>

        <ToastNotification
          show={toastShow}
          autoHide={toastAutoHide}
          message={toastMessage}
          clickClose={() => setToastShow(false)}
        />
      </main>

      <Footer />
    </div>
  );
}

export default Settings;
